
import { Debounce } from 'lodash-decorators'
import { o } from 'ohash/dist/shared/ohash.DTXTHv91'
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop({ default: () => [] }) tabsList: {
    key: string
    url: string
    name: string
  }[]
  @Prop({ default: 0 }) currentTab: number

  @Ref()
  tabActive: HTMLDivElement

  @Debounce(300)
  changeTabs(idx: number) {
    if (idx == this.currentTab) return

    let offset = this.tabActive.offsetLeft // 获取 activeTabs 的left值

    if (this.currentTab > idx) {
      for (let i = this.currentTab - 1; i >= idx; i--) {
        offset = offset - Math.floor(this.$refs[`tabs-${i}`]![0].offsetWidth) - 10
      }
    } else {
      for (let i = this.currentTab; i < idx; i++) {
        offset = offset + Math.floor(this.$refs[`tabs-${i}`]![0].offsetWidth) + 10
      }
    }

    this.tabActive.style.left = `${offset}px`

    this.tabActive.style.width = `${Math.floor(this.$refs[`tabs-${idx}`]![0].offsetWidth)}px` // 解决不同宽度tabs问题

    this.$emit('updateBook', idx)
  }

  // tabs初始化
  initTabs() {
    let offset = 6 // 获取 activeTabs 的left值

    if (this.currentTab > 0) {
      for (let i = 0; i < this.currentTab; i++) {
        offset = offset + Math.floor(this.$refs[`tabs-${i}`]![0].offsetWidth) + 10
      }
    }

    this.tabActive.style.left = `${offset}px`

    this.tabActive.style.width = `${Math.floor(this.$refs[`tabs-${this.currentTab}`]![0].offsetWidth)}px` // 解决不同宽度tabs问题
  }

  created(): void {}

  mounted(): void {
    this.initTabs()
  }

  updated(): void {}

  destroyed(): void {}
}
